'use strict';

import Api from './../abstract'
import { APP_TOKEN_NAME } from '@/config'
import { getQueryStringPhase2 } from '@/utils'

export let GET_LIST_FILE_CATEGORIES = (params, successCallback, errorCallback) => {
    let filter = params.payload.filter || null
    let sort = params.payload.sort || null
    let page = params.payload.page || null
    let url = `${process.env.VUE_APP_API_URL}/admin/file-categories?${getQueryStringPhase2(filter, sort, page)}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };

    return new Api(url, 'get', successCallback, errorCallback, { headers })
};
export let GET_LIST_FILE = (params, successCallback, errorCallback) => {
    let filter = params.payload.filter || null
    let sort = params.payload.sort || null
    let search = params.payload.search || null
    let page = params.payload.page || null
    let url = `${process.env.VUE_APP_API_URL}/admin/files?${getQueryStringPhase2(filter, sort, page, search)}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };

    return new Api(url, 'get', successCallback, errorCallback, { headers })
};

export let DELETE_FILE_CATEGORIES = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/file-categories/${params.payload.category_id}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
        'content-type': 'application/json'
    };
    return new Api(url, 'delete', successCallback, errorCallback, { headers })
};

export let DISABLED_FILE_CATEGORIES = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/file-categories/${params.payload.category_id}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
        'content-type': 'application/json'
    };
    return new Api(url, 'patch', successCallback, errorCallback, { headers })
};

export let DELETE_FILE = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/files/${params.payload.file_id}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
        'content-type': 'application/json'
    };
    return new Api(url, 'delete', successCallback, errorCallback, { headers })
};

export let DISABLED_FILE = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/files/${params.payload.file_id}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
        'content-type': 'application/json'
    };
    return new Api(url, 'patch', successCallback, errorCallback, { headers })
};

export let GET_DETAIL_CATEGORIES = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/file-categories/${params.payload.category_id}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
        'content-type': 'application/json'
    };
    return new Api(url, 'get', successCallback, errorCallback, { headers })
};


export let UPLOAD_FILE = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/upload-file`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
        'content-type': 'application/json'
    };
    let data = params.payload.data
    return new Api(url, 'post', successCallback, errorCallback, { headers , data })
};

export let CREATE_CATEGORIES = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/file-categories`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
        'content-type': 'application/json'
    };
    let data = params.payload.data
    return new Api(url, 'post', successCallback, errorCallback, { headers , data })
};


export let UPDATE_CATEGORIES = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/file-categories/${params.payload.data.id}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
        'content-type': 'application/json'
    };
    let data = params.payload.data
    return new Api(url, 'put', successCallback, errorCallback, { headers , data })
};

export let CREATE_FILE = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/files`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
        'content-type': 'application/json'
    };
    let data = params.payload.data
    return new Api(url, 'post', successCallback, errorCallback, { headers , data })
};

export let SWAP_CATEGORY = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/file-categories/swap`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
        'content-type': 'application/json'
    };
    let data = params.payload.data
    return new Api(url, 'patch', successCallback, errorCallback, { headers , data })
};
export let SWAP_FILE = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/files/swap`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
        'content-type': 'application/json'
    };
    let data = params.payload.data
    return new Api(url, 'patch', successCallback, errorCallback, { headers , data })
};
export let UPDATE_PASSWORD_DEFAULT = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/setting/password`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
        'content-type': 'application/json'
    };
    let data = params.payload.data
    return new Api(url, 'put', successCallback, errorCallback, { headers , data })
};
export let GET_PASSWORD_DEFAULT = (params, successCallback, errorCallback) => {
    let url = `${process.env.VUE_APP_API_URL}/admin/setting/password`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`,
        'content-type': 'application/json'
    };
    return new Api(url, 'get', successCallback, errorCallback, { headers  })
};

